import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'site-how-works',
  templateUrl: './how-works.component.html',
  styleUrls: ['./how-works.component.scss']
})
export class HowWorksComponent implements OnInit {
  howTabs = 'tab1';

  constructor() { }

  ngOnInit() {
  }

}
